import React, {useState, useEffect} from 'react';
import { SiteLink } from '../../components';
import { useStore } from '../../store';

import { FaChevronDown } from 'react-icons/fa';
import { useAuth } from '../../auth/index'
//import { SearchBar } from './searchBar';

export function NavBar(props) {
  const open = props.open;
  //const currentLocation = props.currentLocation;
  const { state } = useStore();
  const _useAuth = useAuth();

  const menu = state.menu || { items: [] };

  const currentLocation = state.history && state.history.length > 0? state.history[state.history.length - 1].path : '';
  const depth = 1;
  const activeSession = _useAuth.sessionV2 || _useAuth.session;
  const isAuthenticated = !!(activeSession && (!activeSession.expired || !activeSession.expired()));
  const hasDashboardAccess = !!(activeSession && (activeSession.memberType ||
    (Array.isArray(activeSession.roles) && activeSession.roles.length > 0)));

  const menuItemElts = menu.items.map((item, index) => {
    // Hide the CMS "MEMBERS' LOG IN" item when authenticated; the auth section below replaces it.
    if (item.title === "MEMBERS' LOG IN") {
      if (isAuthenticated) return null;
      return (
        <li className="navBar__item" key={index}>
          <SiteLink className="navBar__link" to={item.url} onClick={props.onCloseMenu}>
            <span>{item.title}</span>
          </SiteLink>
        </li>
      );
    }
    return (
      <MenuItem
        item={item}
        key={index}
        depth={depth}
        onCloseMenu={props.onCloseMenu}
        currentLocation={currentLocation}
        _useAusth={_useAuth}
      />
    );
  });

  // Auth section: rendered independently of the CMS menu so it always appears for logged-in
  // users, even on routes that haven't loaded the CMS menu yet (e.g. /dashboard direct load).
  const onSignOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.onCloseMenu();
    _useAuth.signoutAdmin();
    if (currentLocation === '/') {
      window.location.reload(false);
    }
  };
  const authSectionElts = isAuthenticated ? (
    <MemberAreaMenu
      hasDashboardAccess={hasDashboardAccess}
      onCloseMenu={props.onCloseMenu}
      onSignOut={onSignOut}
      currentLocation={currentLocation}
    />
  ) : null;
  
  return (
    <div className={`navBar ${open ? 'navBar--on' : ''}`} id="sliding-menu">
      {/* <SearchBar onCloseMenu={props.onCloseMenu}/> */}
      <div className="navBar__scrollArea" id="top-menu">
        <nav className="navBar_nav">
          <ul>
            {menuItemElts}
            {authSectionElts}
          </ul>
        </nav>
      </div>
    </div>);

}

function MenuItem(props) {
  const [subMenuOpened, setSubMenuOpened] = useState(false);
  const item = props.item;
  const subItems = item.items || [];
  const currentLocation = props.currentLocation;

  const subItemsElts = subItems.length > 0? subItems.map((subItem, index) =>
    <SubMenuItem item={subItem} key={index} onCloseMenu={props.onCloseMenu} />
  ) : null;


  useEffect(() => {
    //console.log('navbar', currentLocation);
    setSubMenuOpened(false);
  }, [currentLocation])

  function closeMenu() {
    props.onCloseMenu();
  }

  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    setSubMenuOpened(!subMenuOpened);
  }

  return (
    <li className={`navBar__item ${subMenuOpened ? 'navBar__item--open' : ''}`}>
      <SiteLink className="navBar__link" to={item.url} onClick={() => closeMenu()}>
        <span>{item.title}</span>
        {subItemsElts && <span className="navBar__icon" onClick={(e) => toggleSubmenu(e)}><FaChevronDown /></span>}
      </SiteLink>
      {subItemsElts &&
        <ul className={`navBar__subMenu`}>
          {subItemsElts}
        </ul>}
    </li>
  )
}

function SubMenuItem(props) {
  const item = props.item;
  function closeMenu() {
    props.onCloseMenu();
  }

  return (
    <li className="navBar__subItem">
      <SiteLink className="navBar__subLink" to={item.url} onClick={() => closeMenu()}>
        <span>{item.title}</span>
      </SiteLink>
    </li>
  )
}

function MemberAreaMenu({ hasDashboardAccess, onCloseMenu, onSignOut, currentLocation }) {
  const [subMenuOpened, setSubMenuOpened] = useState(false);

  // Collapse the sub-menu whenever the page changes, matching MenuItem behavior.
  useEffect(() => {
    setSubMenuOpened(false);
  }, [currentLocation]);

  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    setSubMenuOpened(o => !o);
  }

  return (
    <li className={`navBar__item ${subMenuOpened ? 'navBar__item--open' : ''}`}>
      <a className="navBar__link" href="#" onClick={toggleSubmenu}>
        <span>MEMBER AREA</span>
        <span className="navBar__icon" onClick={toggleSubmenu}><FaChevronDown /></span>
      </a>
      <ul className="navBar__subMenu">
        {hasDashboardAccess && (
          <li className="navBar__subItem">
            <SiteLink className="navBar__subLink" to="/dashboard" onClick={onCloseMenu}>
              <span>Dashboard</span>
            </SiteLink>
          </li>
        )}
        <li className="navBar__subItem">
          <SiteLink className="navBar__subLink" to="/profile" onClick={onCloseMenu}>
            <span>Profile</span>
          </SiteLink>
        </li>
        <li className="navBar__subItem">
          <SiteLink className="navBar__subLink" to="/" onClick={onSignOut}>
            <span>Sign Out</span>
          </SiteLink>
        </li>
      </ul>
    </li>
  );
}